(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-order-tracking]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('[data-tracking-form]');
      const submit = root.querySelector('[data-tracking-submit]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const loader = root.querySelector('[data-tracking-loader]');
      const message = root.querySelector('[data-tracking-message]');
      const result = root.querySelector('[data-tracking-result]');
      const orderName = root.querySelector('[data-order-name]');
      const statusBadge = root.querySelector('[data-status-badge]');
      const orderDateWrapper = root.querySelector('[data-order-date-wrapper]');
      const orderDate = root.querySelector('[data-order-date]');
      const orderTotal = root.querySelector('[data-order-total]');
      const updatedWrapper = root.querySelector('[data-updated-wrapper]');
      const updatedAt = root.querySelector('[data-updated-at]');
      const itemsWrapper = root.querySelector('[data-tracking-items]');
      const itemsList = root.querySelector('[data-tracking-items-list]');
      const orderDetails = root.querySelector('[data-order-details]');
      const detailsLabel = root.querySelector('[data-details-label]');
      const subtotal = root.querySelector('[data-subtotal]');
      const discount = root.querySelector('[data-discount]');
      const shipping = root.querySelector('[data-shipping]');
      const total = root.querySelector('[data-total]');
      const paymentMethod = root.querySelector('[data-payment-method]');
      const deliveryAddress = root.querySelector('[data-delivery-address]');
      const steps = [...root.querySelectorAll('[data-step]')];
      const labels = steps.map((step) => step.querySelector('.order-tracking__step-name').textContent.trim());
      const defaultSubmitLabel = submitLabel.textContent;
      const genericError = root.dataset.genericError;
      const connectionError = root.dataset.connectionError;
      const locale = document.documentElement.lang || 'ar-EG';

      const formatMoney = (value, currency) => {
        const amount = Number(value || 0);
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EGP' }).format(amount);
        } catch (error) {
          return `${amount.toLocaleString(locale)} ${currency || ''}`.trim();
        }
      };

      const formatDate = (value, includeTime = false) => {
        const date = new Date(value);
        if (Number.isNaN(date.valueOf())) return '';
        const options = includeTime ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'long' };
        return new Intl.DateTimeFormat(locale, options).format(date);
      };

      const showMessage = (text, isError = false) => {
        message.textContent = text;
        message.classList.toggle('order-tracking__message--error', isError);
        message.hidden = false;
      };

      const resetMessage = () => {
        message.hidden = true;
        message.textContent = '';
        message.classList.remove('order-tracking__message--error');
      };

      const setLoading = (isLoading) => {
        submit.disabled = isLoading;
        loader.hidden = !isLoading;
        submitLabel.textContent = isLoading ? root.dataset.loading : defaultSubmitLabel;
      };

      orderDetails.addEventListener('toggle', () => {
        detailsLabel.textContent = orderDetails.open ? root.dataset.hideDetails : root.dataset.viewDetails;
      });

      const renderResult = (order) => {
        const currentStep = Math.min(5, Math.max(1, Number(order.current_step) || 1));
        const currency = order.currency_code || 'EGP';

        steps.forEach((step, index) => {
          const stepNumber = index + 1;
          step.classList.toggle('is-complete', stepNumber < currentStep);
          step.classList.toggle('is-current', stepNumber === currentStep);
          if (stepNumber === currentStep) step.setAttribute('aria-current', 'step');
          else step.removeAttribute('aria-current');
        });

        orderName.textContent = order.name || '';
        statusBadge.textContent = labels[currentStep - 1];
        orderTotal.textContent = formatMoney(order.total, currency);

        const createdLabel = formatDate(order.created_at);
        if (createdLabel) {
          orderDate.dateTime = new Date(order.created_at).toISOString();
          orderDate.textContent = createdLabel;
          orderDateWrapper.hidden = false;
        } else {
          orderDateWrapper.hidden = true;
        }

        subtotal.textContent = formatMoney(order.subtotal, currency);
        discount.textContent = formatMoney(order.discount, currency);
        shipping.textContent = formatMoney(order.shipping, currency);
        total.textContent = formatMoney(order.total, currency);

        const gateways = Array.isArray(order.payment_gateways) ? order.payment_gateways.filter(Boolean) : [];
        paymentMethod.textContent = gateways.length
          ? gateways.map((gateway) => /cash on delivery|\bcod\b/i.test(gateway) ? root.dataset.codLabel : gateway).join('، ')
          : root.dataset.notAvailable;

        const address = order.shipping_address || {};
        const addressLines = [
          address.name,
          address.address1,
          address.address2,
          [address.city, address.province].filter(Boolean).join('، '),
          [address.country, address.zip].filter(Boolean).join(' ')
        ].filter(Boolean);
        deliveryAddress.textContent = addressLines.length ? addressLines.join('\n') : root.dataset.notAvailable;

        itemsList.replaceChildren();
        const items = Array.isArray(order.items) ? order.items : [];
        items.forEach((item) => {
          const itemStep = Math.min(5, Math.max(1, Number(item.current_step) || 1));
          const card = document.createElement('article');
          card.className = 'order-tracking__item';

          let media;
          if (item.image_url) {
            media = document.createElement('img');
            media.src = item.image_url;
            media.alt = item.image_alt || item.name || '';
            media.loading = 'lazy';
            media.className = 'order-tracking__item-image';
          } else {
            media = document.createElement('span');
            media.className = 'order-tracking__item-image order-tracking__item-image--empty';
            media.setAttribute('aria-hidden', 'true');
            media.textContent = '◻';
          }

          let mediaElement = media;
          if (item.product_url) {
            const mediaLink = document.createElement('a');
            mediaLink.className = 'order-tracking__item-image-link';
            mediaLink.href = item.product_url;
            mediaLink.append(media);
            mediaElement = mediaLink;
          }

          const details = document.createElement('div');
          const name = document.createElement('h4');
          name.className = 'order-tracking__item-name';
          if (item.product_url) {
            const nameLink = document.createElement('a');
            nameLink.href = item.product_url;
            nameLink.textContent = item.name || '';
            name.append(nameLink);
          } else {
            name.textContent = item.name || '';
          }

          const meta = document.createElement('p');
          meta.className = 'order-tracking__item-meta';
          const itemCode = document.createElement('span');
          itemCode.textContent = `${root.dataset.itemCodeLabel}: ${item.id || root.dataset.notAvailable}`;
          const quantity = document.createElement('span');
          quantity.textContent = `${root.dataset.quantityLabel}: ${Number(item.quantity) || 1}`;
          meta.append(itemCode, quantity);
          if (item.sku) {
            const sku = document.createElement('span');
            sku.textContent = `${root.dataset.skuLabel}: ${item.sku}`;
            meta.append(sku);
          }

          const prices = document.createElement('p');
          prices.className = 'order-tracking__item-prices';
          const unitPrice = document.createElement('span');
          unitPrice.textContent = `${root.dataset.unitPriceLabel}: `;
          const unitValue = document.createElement('strong');
          unitValue.textContent = formatMoney(item.unit_price, item.currency_code || currency);
          unitPrice.append(unitValue);
          prices.append(unitPrice);

          const quantityValue = Number(item.quantity) || 1;
          const originalPrice = Number(item.unit_price || 0);
          const discountedPrice = item.discounted_unit_price == null
            ? Number(item.line_total || 0) / quantityValue
            : Number(item.discounted_unit_price);
          const hasDiscount = Number.isFinite(discountedPrice) && discountedPrice + 0.005 < originalPrice;
          if (hasDiscount) {
            unitValue.classList.add('order-tracking__original-price--discounted');
            const lineTotal = document.createElement('span');
            lineTotal.textContent = `${root.dataset.lineTotalLabel}: `;
            const lineValue = document.createElement('strong');
            lineValue.className = 'order-tracking__discounted-price';
            lineValue.textContent = formatMoney(discountedPrice, item.currency_code || currency);
            lineTotal.append(lineValue);
            prices.append(lineTotal);
          }

          const itemStatus = document.createElement('span');
          itemStatus.className = 'order-tracking__item-status';
          itemStatus.textContent = labels[itemStep - 1];
          details.append(name, meta, prices, itemStatus);

          const progress = document.createElement('ol');
          progress.className = 'order-tracking__item-progress';
          progress.setAttribute('aria-label', itemStatus.textContent);
          [2, 3, 4, 5].forEach((stage) => {
            const progressItem = document.createElement('li');
            progressItem.classList.toggle('is-active', stage <= itemStep);
            const dot = document.createElement('span');
            dot.className = 'order-tracking__item-progress-dot';
            dot.setAttribute('aria-hidden', 'true');
            const text = document.createElement('span');
            text.textContent = labels[stage - 1];
            progressItem.append(dot, text);
            progress.append(progressItem);
          });

          card.append(mediaElement, details, progress);
          itemsList.append(card);
        });
        itemsWrapper.hidden = items.length === 0;
        orderDetails.open = false;
        orderDetails.hidden = false;
        detailsLabel.textContent = root.dataset.viewDetails;

        if (order.updated_at) {
          const updatedLabel = formatDate(order.updated_at, true);
          if (updatedLabel) {
            updatedAt.dateTime = new Date(order.updated_at).toISOString();
            updatedAt.textContent = updatedLabel;
            updatedWrapper.hidden = false;
          }
        } else {
          updatedWrapper.hidden = true;
        }

        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        resetMessage();
        result.hidden = true;
        orderDetails.hidden = true;

        if (!form.reportValidity()) return;

        const formData = new FormData(form);
        if (formData.get('website')) return;

        const orderNumber = String(formData.get('order_number') || '').replace(/[^0-9]/g, '');
        const phone = String(formData.get('phone') || '').replace(/[^0-9+]/g, '');

        if (!orderNumber || phone.replace(/\D/g, '').length < 10) {
          showMessage(genericError, true);
          return;
        }

        setLoading(true);

        try {
          const response = await fetch(root.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ order_number: orderNumber, phone })
          });
          const data = await response.json().catch(() => ({}));

          if (!response.ok || !data.success || !data.order) {
            showMessage(genericError, true);
            return;
          }

          renderResult(data.order);
        } catch (error) {
          showMessage(connectionError, true);
        } finally {
          setLoading(false);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
